import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, Paper, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { harmonateTokens as ht } from '../../theme/harmonateTokens';
import {
    harmonatePageSx,
    harmonatePageTitleSx,
    harmonateCardSx,
    harmonateDataGridSx,
    harmonateProceedButtonSx,
} from '../../theme/harmonateStyles';

const GLMappingResults = () => {
    const location = useLocation();
    const { data: extractedData = [] } = location.state || {};

    // Define columns based on potential fields (dynamic headers)
    const columns = extractedData && extractedData.length > 0
        ? Object.keys(extractedData[0])
            .filter(key => key !== 'id') // Exclude id if present
            .map(key => ({
                field: key,
                headerName: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
                width: 150,
                ...(key.includes('amount') && { type: 'number' }),
            }))
        : [
            { field: 'FUND_CODE', headerName: 'Fund Code', width: 120 },
            { field: 'FUND_NAME', headerName: 'Fund Name', width: 150 },
            { field: 'GL_ACCOUNT', headerName: 'GL Account', width: 120 },
            { field: 'GL_CODE', headerName: 'GL Code', width: 120 },
            { field: 'GL_DESCRIPTION', headerName: 'GL Description', width: 200 },
            { field: 'TRANSACTION_DATE', headerName: 'Transaction Date', width: 150 },
            { field: 'TRANSACTION_TYPE', headerName: 'Transaction Type', width: 150 },
            { field: 'BATCH_ID', headerName: 'Batch ID', width: 120 },
            { field: 'DESCRIPTION', headerName: 'Description', width: 200 },
            { field: 'DEBIT_AMOUNT', headerName: 'Debit Amount', width: 120, type: 'number' },
            { field: 'CREDIT_AMOUNT', headerName: 'Credit Amount', width: 120, type: 'number' },
            { field: 'TOTAL_AMOUNT', headerName: 'Total Amount', width: 120, type: 'number' },
        ];

    const handleSave = () => {
        alert('Data saved successfully!');
    };

    return (
        <Box sx={harmonatePageSx}>
            <Box sx={{ mb: 2, flexShrink: 0 }}>
                <Typography variant="h6" sx={harmonatePageTitleSx}>
                    GL Mapping Results
                </Typography>
                <Typography variant="body2" sx={{ color: ht.white, opacity: 0.85, fontSize: '13px' }}>
                    Review and Save Mapping Data
                </Typography>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                <Paper elevation={0} sx={{ ...harmonateCardSx, mb: 3, bgcolor: ht.white }}>
                    <Box sx={{ height: 500, width: '100%' }}>
                        <DataGridPro
                            columnResizeMode="onEnd"
                            resizable
                            rows={extractedData}
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5]}
                            disableSelectionOnClick
                            sx={harmonateDataGridSx}
                        />
                    </Box>
                </Paper>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={harmonateProceedButtonSx}
                    >
                        Save
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default GLMappingResults;
